exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-white[data-v-021e5e41] {\n  background-color: white;\n}\n", ""]);

// exports
